import React from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { SettingsActions } from '../../../redux/Settings';

const Container = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const Text = styled.div`
  padding: 0 1em;
  flex: 7;
  color: #d2c8ae;
  text-align: ${(props) => props.align};
`;

const Toggler = styled.label`
  position: relative;
  display: inline-block;
  width: 28px;
  height: 12px;
  margin: 0;
`;

const Input = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
`;

const Slider = styled.span`
  justify-content: center;
  align-items: center;
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #231717;
  border: 1px solid #d2c8ae;
  border-radius: 6px;
  -webkit-transition: 0.4s;
  transition: 0.4s;

  &:before {
    position: absolute;
    content: '';
    height: 14px;
    width: 14px;
    left: -1px;
    bottom: -2px;
    background-color: #863e10;
    border: 1px solid #d2c8ae;
    border-radius: 7px;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    ${(props) => (props.checked ? 'transform: translateX(15px)' : '')};
  }
`;

const Toggle = () => {
  const dispatch = useDispatch();
  const { showIncludedSkills } = useSelector((state) => state.settings);

  return (
    <Container>
      <Text align="right">Forbidden skills</Text>
      <Toggler>
        <Input
          type="checkbox"
          onClick={() =>
            dispatch(SettingsActions.setShowIncludedSkills(!showIncludedSkills))
          }
        />
        <Slider checked={showIncludedSkills} />
      </Toggler>
      <Text>Allowed skills</Text>
    </Container>
  );
};

export default Toggle;
